import { styled } from "@stitches/react";
import TextWithTooltip from "@/components/TextWithTooltip";
import MultipleOrdersIcon from "../Icons/MultipleOrdersIcon";

const Wrapper = styled("div", {
  display: "grid",
  alignItems: "center",
  gap: 10,
});

interface Props {
  name: string;
  mrn: string;
  containsMultipleOrder: boolean;
}

const PatientName = ({ name, mrn, containsMultipleOrder }: Props) => {
  return (
    <Wrapper>
      <div style={{ display: "flex", gap: "5px" }}>
        {containsMultipleOrder && (
          <>
            <TextWithTooltip
              id="multiple-orders"
              text={<MultipleOrdersIcon />}
              textTooltip="Multiple orders pending for this patient"
            />
          </>
        )}

        <TextWithTooltip
          id="patient-icon"
          text={`  Name: ${name}`}
          textTooltip={name}
        />
      </div>
      <TextWithTooltip
        id="patient-mrn"
        text={`MRN: ${mrn}`}
        textTooltip={mrn}
      />
    </Wrapper>
  );
};

export default PatientName;
